export const FETCH_COUPONS_REQUEST = 'FETCH_COUPONS_REQUEST';
export const FETCH_COUPONS_SUCCESS = 'FETCH_COUPONS_SUCCESS';
export const FETCH_COUPONS_FAILURE = 'FETCH_COUPONS_FAILURE';

export const FETCH_COUPON_STATS_REQUEST = 'FETCH_COUPON_STATS_REQUEST';
export const FETCH_COUPON_STATS_SUCCESS = 'FETCH_COUPON_STATS_SUCCESS';
export const FETCH_COUPON_STATS_FAILURE = 'FETCH_COUPON_STATS_FAILURE';

export const FETCH_COUPON_BY_ID_REQUEST = 'FETCH_COUPON_BY_ID_REQUEST';
export const FETCH_COUPON_BY_ID_SUCCESS = 'FETCH_COUPON_BY_ID_SUCCESS';
export const FETCH_COUPON_BY_ID_FAILURE = 'FETCH_COUPON_BY_ID_FAILURE';

export const CREATE_COUPON_REQUEST = 'CREATE_COUPON_REQUEST';
export const CREATE_COUPON_SUCCESS = 'CREATE_COUPON_SUCCESS';
export const CREATE_COUPON_FAILURE = 'CREATE_COUPON_FAILURE';

export const UPDATE_COUPON_REQUEST = 'UPDATE_COUPON_REQUEST';
export const UPDATE_COUPON_SUCCESS = 'UPDATE_COUPON_SUCCESS';
export const UPDATE_COUPON_FAILURE = 'UPDATE_COUPON_FAILURE';

export const DELETE_COUPON_REQUEST = 'DELETE_COUPON_REQUEST';
export const DELETE_COUPON_SUCCESS = 'DELETE_COUPON_SUCCESS';
export const DELETE_COUPON_FAILURE = 'DELETE_COUPON_FAILURE';
